module.exports = __webpack_public_path__ + "img/logo-light-sm.12213114.png";